import { useState } from "react";
import {
  getAll,
  deleteMeetingById,
  cancelMeetingById,
  cancelMeetingAgendaById,
  addMeeting,
  addAgendaAppointment,
  getById,
  getMeetingInfoByid,
  getMeetingTemplateagenda,
  updateMeeting,
  addAgenda
} from "../services/meeting.service";

const INITIAL_SUCCESS_ERROR = {
  getAll: "",
  deleteMeetingById: "",
  cancelMeetingById: "",
  cancelMeetingAgendaById: "",
  addMeeting: "",
  addAgendaAppointment: "",
  getById: "",
  getMeetingTemplateAgenda: "",
};

export const useMeeting = ({ spinner }) => {
  const [meetingList, setMeetingList] = useState([]);
  const [meeting, setMeeting] = useState({});
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);
  const [meetingInfo, setMeetingInfo] = useState([]);

  const getMeeting = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await getAll(params);
    if (response.error) {
      spinner(false);
      setMeetingList(response.data);
      setError({ getAll: response.error });
    } else {
      spinner(false);
      setMeetingList(response.data);
    }
  };

  const getMeetingById = async (id) => {
    clearAlerts();
    spinner(true);
    const response = await getById(id);
    if (response.error) {
      spinner(false);
      setMeeting(response.data);
      setError({ getById: response.error });
    } else {
      spinner(false);
      setMeeting(response.data);
    }

    return response.data;
  };

  async function getMeetingInfoById(culture, id) {
    clearAlerts();
    spinner(true);
    const response = await getMeetingInfoByid(culture, id);
    if (response.error) {
      spinner(false);
      setMeetingInfo(response.data);
      setError({ getById: response.error });
    } else {
      spinner(false);
      setMeetingInfo(response.data);
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.name,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  const deleteMeeting = async (languageId, meetingId) => {
    clearAlerts();
    spinner(true);
    const response = await deleteMeetingById(languageId, meetingId);
    spinner(false);
    if (response.error) {
      setThemesList([]);
      setError({ deleteMeetingById: response.error });
    } else {
      setSuccess({ deleteMeetingById: "deleted" });
      setThemesList(response.data);
    }
  };

  const cancelMeeting = async (languageId, meetingId) => {
    clearAlerts();
    spinner(true);
    const response = await cancelMeetingById(languageId, meetingId);
    spinner(false);
    if (response.error) {
      setThemesList([]);
      setError({ cancelMeetingById: response.error });
    } else {
      setSuccess({ cancelMeetingById: "disabled" });
      setThemesList(response.data);
    }
  };

  const cancelMeetingSlot = async (languageId, request) => {
    clearAlerts();
    spinner(true);
    const response = await cancelMeetingAgendaById(languageId, request);
    spinner(false);
    if (response.error) {
      setError({ cancelMeetingAgendaById: response.error });
      return null;
    } else {
      setSuccess({ cancelMeetingAgendaById: "disabled" });
      return response.data;
    }
  };

  const create = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await addMeeting(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };

  const createAgenda = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await addAgenda(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
    return response
  };

  const createAgendaAppointment = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await addAgendaAppointment(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };


  async function getMeetingTemplateAgenda(request) {
    clearAlerts();
    spinner(true);
    const response = await getMeetingTemplateagenda(request);
    if (response.error) {
      spinner(false);
      return response.data;
      setError({ getById: response.error });
    } else {
      spinner(false);
      return response.data;
    }
  };

  const update = async (id, request) => {
    clearAlerts();
    spinner(true);
    const response = await updateMeeting(id, request);

    spinner(false);
    if (response.error) {
      setError({ update: response.error });
    } else {
      setSuccess({ update: "update" });
    }
  };

  return {
    getMeeting,
    sanitizeForTable,
    deleteMeeting,
    cancelMeeting,
    cancelMeetingSlot,
    create,
    createAgendaAppointment,
    getMeetingById,
    getMeetingInfoById,
    createAgenda,
    getMeetingTemplateAgenda,
    meetingList,
    meeting,
    success,
    error,
    meetingInfo,
    update
  };
};
